import { useEffect, useState, useMemo } from "react";
import { adminApi } from "../../api";

/**
 * Loads admin tables list, applies a text filter, and groups results into:
 *  - sectionGroups (special UI sections like "GERAL")
 *  - schemas (fallback grouping by SQL schema)
 */
export default function useAdminTables({ user }) {
  const [tables, setTables] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    if (!user) return;
    adminApi.listTables()
      .then((r) => setTables(r.data || []))
      .catch((e) => console.error("listTables", e));
  }, [user]);

  const { filtered, sectionGroups, schemas } = useMemo(() => {
    const f = tables.filter((t) => !search
      || t.label.toLowerCase().includes(search.toLowerCase())
      || t.key.toLowerCase().includes(search.toLowerCase()));
    const sg = {}; const sc = {};
    for (const t of f) {
      if (t.section) {
        const key = String(t.section).toUpperCase();
        if (!sg[key]) sg[key] = [];
        sg[key].push(t);
      } else {
        if (!sc[t.schema]) sc[t.schema] = [];
        sc[t.schema].push(t);
      }
    }
    for (const g of Object.values(sg)) g.sort((a, b) => a.label.localeCompare(b.label));
    for (const g of Object.values(sc)) g.sort((a, b) => a.label.localeCompare(b.label));
    return { filtered: f, sectionGroups: sg, schemas: sc };
  }, [tables, search]);

  return { tables, search, setSearch, filtered, sectionGroups, schemas };
}
